import { useMutationsAlerts } from '../../hooks/use-mutations-alerts';

export const MutationsNotifier = () => {
  useMutationsAlerts();
  return null;
};
